import ConfirmItemType4 from "./confirmItemType4";

export default ConfirmItemType4;
